
import Vue from 'vue' /**引入vue框架 */
import App from './App'/**引入根组件 */
import router from './router'/**引入路由设置 */
import i18n from './i18n'/**引入i18n国际化 */
import ElementUI from 'element-ui'/**引入elementUI样式 */
import scroll from 'vue-seamless-scroll';/**引入滚动组件 */
import VueCookies from 'vue-cookies';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css'; //响应式栅格华

import * as cookie from '@/api/libs/cookie'
import './styles.scss'
import 'font-awesome/css/font-awesome.min.css'
Vue.prototype.$cookie = cookie
import config from '@/config'
import { Message } from "element-ui";
import { addViewCount } from '@/api/data.js'
Vue.use(Message);
Vue.prototype.$message = Message;
const Base64 = require('js-base64').Base64
Vue.config.productionTip = false/**关闭生产模式下给出的提示 */
Vue.use(ElementUI);
Vue.use(scroll);
Vue.use(VueCookies);
Vue.config.productionTip = false
Vue.prototype.$config = config

addViewCount().then(res=>{});
/* eslint-disable no-new */
/**定义一个新实例 */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },/**引入根组件的APP.vue */
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js